import { forwardRef } from "react";

import { tw } from "~/utils";

export const TableHead = forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={tw(
      "text-indigo bg-white p-3 align-top text-base font-medium normal-case",
      className,
    )}
    {...props}
  />
));
TableHead.displayName = "TableHead";
